import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { useFleets } from '../../../hooks';
import { TRANSLATION_DOMAINS } from '../../../consts';

const { EXCEPTIONS_LIST: domain } = TRANSLATION_DOMAINS;

interface Props {
	fleetId: number;
}

const FleetCell = ({ fleetId }: Props) => {
	const { t } = useTranslation();
	const { getFleetById } = useFleets();
	const label = fleetId ? getFleetById(fleetId)?.name || t(`${domain}.UNKNOWN`) : t(`${domain}.UNASSIGNED`);

	return <span title={label}>{label}</span>;
};

export default observer(FleetCell);
